import { render, staticRenderFns } from "./VendorAccount.vue?vue&type=template&id=1723c876&scoped=true&"
import script from "./VendorAccount.vue?vue&type=script&lang=js&"
export * from "./VendorAccount.vue?vue&type=script&lang=js&"
import style0 from "./VendorAccount.vue?vue&type=style&index=0&id=1723c876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1723c876",
  null
  
)

export default component.exports